import { render, staticRenderFns } from "./UserGroupSelection.vue?vue&type=template&id=507f2efa&scoped=true"
import script from "./UserGroupSelection.vue?vue&type=script&lang=js"
export * from "./UserGroupSelection.vue?vue&type=script&lang=js"
import style0 from "./UserGroupSelection.vue?vue&type=style&index=0&id=507f2efa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507f2efa",
  null
  
)

export default component.exports